export const HtmlField: React.FC<{
  html: string;
  className?: string;
}> = ({ html, className }) => <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
